const language = 'italian';
export const langDir = 'ltr';

export default language;
